import { useFormSelector } from 'mrf/redux/ReduxHelper';
import { Col, Grid } from 'mrf/view/Grid';
import Report from 'mrf/view/Report';
import {useTranslation} from "react-i18next";
import dateFormatter from 'mrf/utils/DateFormatter';
import DateField from 'mrf/view/DateField';
import FetcherObjectSelect from 'mrf/view/FetcherObjectSelect';

export default function CommunicationLicensesReport({ history, match }) {

    const context = useFormSelector({
        resource: 'communicationlicensesReport',
    });

    const {t} = useTranslation();

    const tableFields = [
        {name: t('License Type'), keys: ['communicationLicenseType', 'name'], map:t},
        {name: t('Importing Country'), keys: ['communicationProcess', 'importingCountry', 'institution','country','name']},
        {name: t('Exporting Country'), keys: ['communicationProcess', 'exportingCountry', 'institution','country','name']},
        { name: t('Issue Date'), key: 'issueDate', map: dateFormatter },
        { name: t('Expiration Date'), key: 'expirationDate', map: dateFormatter },
        {name: t('Transfer Code'), key: ['communicationProcessId']},
    ];

    const fields = [{ name: t('Name'), key: 'name'}];

    return <Report
        match={match}
        context={context}
        history={history}
        title={t('Communication Licenses Report')}
        tableFields={tableFields}
    >
        <Grid>
            <Col size={4}>
                <FetcherObjectSelect
                    label={t('Communication License Type')}
                    field='communicationLicenseTypeId'
                    resource='communicationLicenseTypes'
                    displayAttribute='name'
                    fields= {fields}
                />
            </Col>
            <Col size={4}>
                <FetcherObjectSelect
                    label={t('Importing Country')}
                    resource='countries'
                    field='importingCountryId'
                    displayAttribute='name'
                    fields= {fields}
                />
            </Col>
            <Col size={4}>
                <FetcherObjectSelect
                    label={t('Exporting Country')}
                    resource='countries'
                    field='exportingCountryId'
                    displayAttribute='name'
                    fields= {fields}
                />
            </Col>
           <Col size={6}>
                <DateField
                    label={t('Issue Date - Start')}
                    field='issueDateStart'
                />
            </Col>

            <Col size={6}>
                <DateField
                    label={t('Issue Date - End')}
                    field='issueDateEnd'
                />
            </Col>

            <Col size={6}>
                <DateField
                    label={t('Expiration Date - Start')}
                    field='expirationDateStart'
                />
            </Col>

            <Col size={6}>
                <DateField
                    label={t('Expiration Date - End')}
                    field='expirationDateEnd'
                />
            </Col>

        </Grid>
    </Report>
}